import { takeLatest, put, select, cancel } from 'redux-saga/effects';
import { defaultPatientIdSelector } from '../selectors/channels';
import {
  lastUserIdSelector,
  lastSocialIdSelector,
} from '../selectors/settings';
import { typeSelector } from '../selectors/filters';
import { consts as context } from '../../context';
import { consts as settings } from '../settings';
import { consts as chatConsts } from '../../chatConnection';
import { isDesktop } from '../../../utils/mobileHelpers';
import { targetUserIdSelector } from '../../context/selectors';

function* selectNextTargetUserWorker() {
  // let mobile user to select default chat manually
  if (!isDesktop()) return;

  const state = yield select();
  const lastUserId = lastUserIdSelector(state);
  const lastSocialId = lastSocialIdSelector(state);
  const targetUserId = yield select(targetUserIdSelector);
  const userId = !lastUserId ? defaultPatientIdSelector(state) : lastUserId;
  const filterType = yield select(typeSelector);

  // TODO REFACTOR LANDING
  switch (filterType) {
    case 'social':
      yield put({
        type: context.SET_TARGET_USER_ID,
        payload: null,
      });
      break;
    case 'all':
      if (userId && !lastSocialId) {
        if (targetUserId === lastUserId) yield cancel();

        yield put({
          type: settings.SET_LAST_USER_ID,
          payload: { id: userId },
        });
        yield put({
          type: settings.REMOVE_LAST_SOCIAL_ID,
        });
      } else {
        yield put({
          type: context.SET_TARGET_USER_ID,
          payload: null,
        });
      }
      break;
    default:
      if (targetUserId === lastUserId) yield cancel();

      yield put({
        type: settings.SET_LAST_USER_ID,
        payload: { id: userId },
      });
      break;
  }
}

export default function* selectNextTargetUserSaga() {
  yield takeLatest(
    [chatConsts.SET_AVAILABLE_CHANNELS, settings.UPDATE_LAST_USER_ID],
    selectNextTargetUserWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/board/sagas/selectNextTargetUser.js